/*
Feedback form which allows users to click one of three emojis to provide feedback on the chatbot. After an emoji is clicked a text box and submit button should show
*/
import React, { useState } from 'react'

interface Props {
    config: any
    closeFeedbackForm: (submit: boolean) => void
    send: (msg: string, payload: string, options?: any) => void
    mainSizing: {
        width: string
        height: string
        menuOverlayHeight: string
    }
    closeWidget: () => void
}

const FeedBackForm: React.FC<Props> = ({ config, closeFeedbackForm, send, mainSizing, closeWidget }) => {
    const [feedback, setFeedback] = useState('')
    const [extraFeedback, setExtraFeedback] = useState('')
    const [desiredInfo, setDesiredInfo] = useState('')
    const [foundInfo, setFoundInfo] = useState(false)
    const [notFoundInfo, setNotFoundInfo] = useState(false)
    const [closingAnimation, setClosingAnimation] = useState(false)
    const [submitted, setSubmitted] = useState(false)

    const { header_bg_color, buttons_bg_color, buttons_text_color, further_info_link, further_info_link_text, further_info_text } = config

    const GREAT_FEEDBACK_HEADER = "We're thrilled to hear that you had a positive experience! Could you let us know what you liked the most?"
    const OKAY_FEEDBACK_HEADER =
        "Thanks for your feedback! We'd love to hear more about your experience. Is there anything specific that stood out to you or that we could do better?"
    const BAD_FEEDBACK_HEADER =
        "We're sorry to hear that you're not completely satisfied. Could you please share what went wrong or what we could improve to make your experience better?"

    const handleUserExperienceSubmit = (userExperience: string) => {
        // Send user experience to server
        send('', userExperience, { msg_type: 'user_experience', expectResponse: false })
        setFeedback(userExperience)
    }

    const handleFeedbackSubmit = () => {
        // Send feedback to server
        const didFindInfo = !foundInfo && !notFoundInfo ? 'unknown' : foundInfo.valueOf()
        send('', extraFeedback + ' | ' + desiredInfo + ' | ' + didFindInfo, { msg_type: 'user_feedback', expectResponse: false })
        setSubmitted(true)
        setTimeout(() => {
            handleCloseFeedbackForm(true)
        }, 3000)
    }

    const handleCloseFeedbackForm = (submitted: boolean) => {
        setClosingAnimation(true)
        setTimeout(() => {
            closeFeedbackForm(submitted)
            setClosingAnimation(false)
        }, 480)
    }

    console.log(foundInfo)

    return (
        <div
            className={closingAnimation ? 'feedback-form-fade-out' : 'feedback-form'}
            style={{ borderColor: header_bg_color, width: `calc(${mainSizing.width} - 30px)`, height: `calc(${mainSizing.height} - 55px)` }}
        >
            {!feedback && (
                <>
                    <div>How was your experience?</div>
                    <div className='feedback-emojis'>
                        <span onClick={() => handleUserExperienceSubmit('bad')}>
                            😞 <div>Poor</div>
                        </span>
                        <span onClick={() => handleUserExperienceSubmit('okay')}>
                            😐 <div>Okay</div>
                        </span>
                        <span onClick={() => handleUserExperienceSubmit('great')}>
                            😃 <div>Good</div>
                        </span>
                    </div>
                </>
            )}
            {feedback ? (
                submitted ? (
                    <>
                        <div className='feedback-text'>Your feedback has been submitted. Thank you!</div>
                        {notFoundInfo && further_info_link && further_info_link_text && further_info_text ? (
                            <p>
                                {further_info_text}
                                <a
                                    target='_blank'
                                    href={further_info_link}
                                    rel='noreferrer'
                                >
                                    {further_info_link_text}
                                </a>
                            </p>
                        ) : null}
                    </>
                ) : (
                    <div
                        className='feedback-text'
                        style={{ overflowY: 'auto' }}
                    >
                        <p>
                            {feedback === 'great' && GREAT_FEEDBACK_HEADER}
                            {feedback === 'okay' && OKAY_FEEDBACK_HEADER}
                            {feedback === 'bad' && BAD_FEEDBACK_HEADER}
                        </p>
                        <textarea
                            value={extraFeedback}
                            onChange={e => setExtraFeedback(e.target.value)}
                            // placeholder='Enter your feedback here...'
                        />
                        <p>What information were you looking for?</p>
                        <textarea
                            value={desiredInfo}
                            onChange={e => setDesiredInfo(e.target.value)}
                            // placeholder='Enter your feedback here...'
                        />
                        <p>Did you find information that was relevant to you on AccessAva?</p>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <input
                                type='checkbox'
                                id='yes'
                                checked={foundInfo}
                                onChange={e => {
                                    setFoundInfo(true)
                                    setNotFoundInfo(false)
                                }}
                            ></input>
                            <label htmlFor='yes'>Yes</label>
                            <input
                                type='checkbox'
                                id='no'
                                checked={notFoundInfo}
                                onChange={e => {
                                    setFoundInfo(false)
                                    setNotFoundInfo(true)
                                }}
                            ></input>
                            <label htmlFor='no'>No</label>
                        </div>
                        {notFoundInfo && further_info_link && further_info_link_text && further_info_text ? (
                            <p>
                                {further_info_text}
                                <a
                                    target='_blank'
                                    href={further_info_link}
                                    rel='noreferrer'
                                >
                                    {further_info_link_text}
                                </a>
                            </p>
                        ) : null}
                        <div className='feedbackButtons'>
                            <button
                                onClick={() => handleCloseFeedbackForm(false)}
                                style={{
                                    backgroundColor: buttons_text_color,
                                    color: buttons_bg_color,
                                    borderStyle: 'solid',
                                    borderColor: buttons_bg_color,
                                    margin: '5px',
                                }}
                            >
                                Back
                            </button>
                            <button
                                onClick={() => closeWidget()}
                                style={{
                                    backgroundColor: buttons_text_color,
                                    color: buttons_bg_color,
                                    borderStyle: 'solid',
                                    borderColor: buttons_bg_color,
                                    margin: '5px',
                                }}
                            >
                                Close Widget
                            </button>
                            <button
                                onClick={() => handleFeedbackSubmit()}
                                disabled={extraFeedback === '' && desiredInfo === '' && !foundInfo && !notFoundInfo}
                                title={extraFeedback === '' ? 'Add feedback to submit' : 'Submit'}
                                style={{ backgroundColor: buttons_bg_color, color: buttons_text_color, margin: '5px' }}
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                )
            ) : (
                <button
                    onClick={() => handleCloseFeedbackForm(false)}
                    style={{ backgroundColor: buttons_bg_color, color: buttons_text_color }}
                >
                    Back
                </button>
            )}
        </div>
    )
}

export default FeedBackForm
